export default "__VITE_ASSET__CXUO1Hbh__"